
// aos js
AOS.init({
  duration: 1200,
});
// mobile version
AOS.init({disable: 'mobile'});
	AOS.init({
	disable: function() {
	  var maxWidth = 800;
	  return window.innerWidth < maxWidth;
	}
});

// banner slider js

$('#banner-slider').slick({
  dots: true,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  //infinite: false,
  fade:true,
  // cssEase: 'linear',
  cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        //infinite: true,
        //dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});


/*#### category slider js start ###*/ 

$('#category-slider').slick({
  dots: false,
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow: '<button class="slick-prev slick-arrow"><i class="fa-solid fa-arrow-left"></i></button>',
  nextArrow: '<button class="slick-next slick-arrow"><i class="fa-solid fa-arrow-right"></i></button>',
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
  
});


// testimonials slider js
$('#testimonials-slider').slick({
  dots: false,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 3000,
  //infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: '<button class="slick-prev slick-arrow"><i class="fa-solid fa-arrow-left"></i></button>',
  nextArrow: '<button class="slick-next slick-arrow"><i class="fa-solid fa-arrow-right"></i></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        //infinite: true,
        //dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});

/*#### category slider js start ###*/ 

$('#insta-slider').slick({
  dots: false,
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  prevArrow: '<button class="slick-prev slick-arrow"><i class="fa-solid fa-arrow-left"></i></button>',
  nextArrow: '<button class="slick-next slick-arrow"><i class="fa-solid fa-arrow-right"></i></button>',
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
  
});


/*####### Shop page js*/ 
$(document).ready(function () {
    $(".category_head .plusminus").click(function () {
        let head = $(this).parent(); // go up to .accordion_head
        let body = head.next(".category_nav_wrap"); // get its sibling body

        if (body.is(':visible')) {
            body.slideUp(300);
            $(this).text('+');
        } else {
            $(".category_nav_wrap").slideUp(300); // close all
            $(".plusminus").text('+');         // reset all plus
            body.slideDown(300);               // open this one
            $(this).text('-');                 // set minus
        }
    });
});

$(document).ready(function () {
  $('.sidebar-tigger').on('click', function () {
    $('.left-sidebar').toggleClass('active');
    $(this).toggleClass('active');
  });
  $('.close-sidebar-btn').on('click', function () {
    $('.left-sidebar').removeClass('active');
  });
});